// Minimal Google Analytics (gtag) helper for GA4
export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || '';

// pageview sends a page_view event to GA4
export const pageview = (url: string) => {
  if (!GA_MEASUREMENT_ID) return;
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).gtag('event', 'page_view', {
      page_path: url,
    });
  } catch (e) {
    // ignore in non-browser environments
  }
};

// event wrapper
export const event = ({
  action,
  params,
}: {
  action: string;
  params: Record<string, unknown>;
}) => {
  if (!GA_MEASUREMENT_ID) return;
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).gtag('event', action, params);
  } catch (e) {
    // ignore
  }
};

